<template>
  <div>
    <Swiper
      :navigation="{
        nextEl: '.s-coming-soon__next',
        prevEl: '.s-coming-soon__prev',
      }"
      :pagination="{
        el: '.s-coming-soon__pagination',
        type: 'bullets',
        clickable: true,
      }"
      :breakpoints="{
        320: {
          slidesPerView: 1,
          spaceBetween: 8,
        },
        1279: {
          slidesPerView: 'auto',
          spaceBetween: 32,
        },
      }"
      slides-per-view="1"
      :space-between="35"
      @slide-change="onSoonSlideChange">
      <SwiperSlide
        v-for="(record, index) in records"
        :key="index"
        class="s-coming-soon__slide">
        <div v-if="desktop" class="s-coming-soon__wrapper">
          <div class="s-coming-soon__content">
            <div class="s-coming-soon__img">
              <img :src="record.img" :alt="record.title" />
            </div>
            <div class="s-coming-soon__container">
              <div class="e-label e-label--bg e-label--ticket">
                <span>{{ dictionary.ticketsFrom }}</span>
                {{ showDueDate(record.due) }}
              </div>
              <div class="s-coming-soon__content-container">
                <div class="s-coming-soon__content-container__title">
                  {{ record.title }}
                </div>

                <div class="s-coming-soon__content-container__subtitle">
                  {{ record.subTitle }}
                </div>

                <!-- <div
                  class="s-coming-soon__content-container__description"
                  v-html="record.desc"></div> -->

                <div class="b-hor-align b-hor-align--gap-16">
                  <div v-if="record.pg" class="e-k">{{ record.pg }}</div>
                  <!-- <div v-if="record.genre" class="movie-attr--movie">
                    {{ record.genre }}
                  </div> -->
                  <div v-if="record.dur" class="movie-attr--time">
                    <span>{{ record.dur }}</span>
                  </div>
                </div>
              </div>

              <a :href="record.url" type="button" class="btn-secondary">
                {{ dictionary.more }}
              </a>
            </div>
          </div>
        </div>

        <div v-if="tablet || mobile" class="s-coming-soon__wrapper">
          <div class="s-coming-soon__img--mobile">
            <img :src="record.img" :alt="record.title" />
          </div>
          <div class="s-coming-soon__content--mobile">
            <div class="e-label e-label--ticket s-coming-soon__date--mobile">
              <span>{{ dictionary.ticketsFrom }}</span>
              {{ showDueDate(record.due) }}
            </div>
            <div class="s-coming-soon__content-container__title">
              {{ record.title }}
            </div>
            <div class="s-coming-soon__content-container__subtitle">
              {{ record.subTitle }}
            </div>
            <!-- <div
              class="s-coming-soon__content-container__description"
              v-html="record.desc"></div> -->

            <div class="s-coming-soon__attr b-hor-align b-hor-align--gap-16">
              <div v-if="record.pg" class="e-k">{{ record.pg }}</div>
              <!-- <div v-if="record.genre" class="movie-attr--movie">
                {{ record.genre }}
              </div> -->
              <div v-if="record.dur" class="movie-attr--time">
                <span>{{ record.dur }}</span>
              </div>
            </div>
            <div class="s-coming-soon__cta-wrapper--mobile">
              <a :href="record.url" class="btn-secondary btn--block">
                {{ dictionary.more }}
              </a>
              <button
                type="button"
                class="btn-secondary btn--block"
                @click="() => (showReminderModal = true)">
                {{ dictionary.notify }}
              </button>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <div class="swiper__nav">
        <div
          v-if="desktop"
          class="swiper-button-prev s-coming-soon__prev"></div>
        <div class="swiper-pagination s-coming-soon__pagination"></div>
        <div
          v-if="desktop"
          class="swiper-button-next s-coming-soon__next"></div>
      </div>
    </Swiper>
    <nav
      v-if="configuration.stripBtnUrl"
      class="s-coming-soon__btn-area clearfix">
      <a :href="configuration.stripBtnUrl" class="s-coming-soon__cta">
        <span>{{ dictionary.stripBtnTitle }}</span>
      </a>
    </nav>
    <div v-if="desktop">
      <MovieReminder
        v-if="selected && selected.due"
        :key="selectedMovieKey"
        :start="configuration.now"
        :dictionary="notifyDictionary"
        :configuration="configuration"
        :due="selected.due"
        :movie-id="selectedMovieKey" />
    </div>
    <ModalOverlay v-model="showReminderModal">
      <template #header>
        <i class="icon-alarm"></i>
        <div class="b-pop-up__header__title">{{ dictionary.notify }}</div>
      </template>
      <template #body>
        <div class="b-pop-up__content">
          <MovieReminder
            v-if="selected && selected.due"
            :key="selectedMovieKey"
            :start="configuration.now"
            :dictionary="notifyDictionary"
            :configuration="configuration"
            :due="selected.due"
            :movie-id="selectedMovieKey"
            :mobile-ui-config="{
              mainClass: '',
              showTitle: false,
              showMobileTitle: true,
            }"
            :selected-movie="selected" />
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { getData } from '../../lib/lib'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { getFormattedDateWithSeparators } from '../../lib/date'
import MovieReminder from '../components/MovieReminder.vue'
import useViewport from '../../features/viewport.js'
const { desktop, tablet, mobile } = useViewport()
const {
  records: slides,
  dictionary: dictionaryData,
  configuration: config,
  notifyDictionary,
} = getData('comingSoonStripData')
import ModalOverlay from '../components/ModalOverlay.vue'

const records = ref([])
const cpage = ref(0)
// const selectedId = ref('')
const dictionary = ref({})
const configuration = ref({})
// const openNotifier = ref(false)
const showReminderModal = ref(false)

const selected = computed(() => {
  return records.value[cpage.value]
})
const selectedMovieKey = computed(() => {
  return selected.value.movieId
})
onMounted(() => {
  if (slides && slides.length) {
    records.value = [...slides]
  }
  dictionary.value = dictionaryData
  configuration.value = config
})
const onSoonSlideChange = (e) => {
  e.pagination.update()
  e.navigation.update()
  cpage.value = e.activeIndex
}
const showDueDate = (date) => {
  return getFormattedDateWithSeparators(
    date,
    'en-GB',
    { year: 'numeric', month: '2-digit', day: '2-digit' },
    '.'
  )
}
</script>
